export class ElementHelpers {
	/**
	 * Check whether or not the parent has a certain class
	 *
	 * @param element
	 * @param className
	 * @returns {boolean}
	 */
	static hasParentWithClass(element, className) {
		return ElementHelpers.getParentByClass(element, className) !== undefined;
	}

	/**
	 * Get a parent element by classname
	 *
	 * @param current
	 * @param className
	 * @returns {*}
	 */
	static getParentByClass(current, className) {
		let parent = current.parentNode;
		if (parent.classList.contains(className)) {
			return parent;
		} else if (ElementHelpers.isBody(parent)) {
			return undefined;
		}
		return ElementHelpers.getParentByClass(parent, className);
	}

	/**
	 * Get a parent element by tagname
	 *
	 * @param current
	 * @param parentTagName
	 * @returns {*}
	 */
	static getParentByTagName(current, parentTagName) {
		let parent = current.parentNode;
		if (parent.tagName.toLowerCase() === parentTagName) {
			return parent;
		} else if (ElementHelpers.isBody(parent)) {
			return undefined;
		}
		return ElementHelpers.getParentByTagName(parent, parentTagName);
	}

	/**
	 * Check whether or the current element is the body
	 *
	 * @param element
	 * @returns {boolean}
	 */
	static isBody(element) {
		return element.tagName.toLowerCase() === 'body';
	}

	/**
	 * Check whether or not the link is inpage or goes to
	 * another page (starts with hash or not)
	 * @param element
	 * @returns {boolean}
	 */
	static isExternalLink(element) {
		return (element.href && element.href[0] !== '#');
	}

	/**
	 * Check whether the element is visible in the browser viewport
	 * @param element
	 * @returns {boolean}
	 */
	static isInsideViewport(element) {
		const rect = element.getBoundingClientRect();
		return (
			rect.top >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight) ||
			rect.bottom >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
		);
	}

	/**
	 * Add event listeners on a list of elements
	 * @param elements
	 * @param eventType
	 * @param eventHandler
	 */
	static addEventListeners(elements, eventType, eventHandler) {
		for (let i = 0; i < elements.length; i = i + 1) {
			elements[i].addEventListener(eventType, eventHandler);
		}
	}

	/**
	 * Trigger an event on a specified element
	 * @param elementList {NodeList}
	 * @param eventType
	 */
	static triggerEvents(elementList, eventType) {
		for (let i = 0; i < elementList.length; i = i + 1) {
			ElementHelpers.triggerEvent(elementList[i], eventType);
		}
	}

	/**
	 * Trigger an event on a specified element
	 * @param element {Node}
	 * @param eventType
	 */
	static triggerEvent(element, eventType) {
		let evt;

		if (typeof(Event) === 'function') {
			evt = new Event(eventType);
		} else {
			evt = document.createEvent('Event');
			evt.initEvent(eventType, true, true);
		}

		element.dispatchEvent(evt);
	}

	/**
	 *
	 * @param element
	 */
	static removeElement(element) {
		if (element) {
			if (typeof element.remove === 'function') {
				element.remove();
			} else {
				element.parentElement.removeChild(element);
			}
		}
	}

	/**
	 *
	 * @param selector
	 * @param element, will be body when no element is presented
	 * @returns {*}
	 */
	static getElementsAsArray(selector, element = document.querySelector('body')) {
		// transforming into real array
		const allItems = element.querySelectorAll(selector);
		return Array.prototype.slice.call(allItems);
	}

	static isHtmlElement(element) {
		return (
			typeof HTMLElement === 'object' ? element instanceof HTMLElement :
				element && typeof element === 'object' && element !== null && element.nodeType === 1 && typeof element.nodeName === 'string'
		);
	}
}
